import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { applications } from '../mock';
import { Link } from 'react-router-dom';

const ApplicationsPage = () => {
  return (
    <div data-testid="applications-page" className="bg-white pt-24 sm:pt-28 pb-16 sm:pb-24">
      {/* Page Header */}
      <section className="py-10 sm:py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <p className="font-rajdhani text-brand font-semibold text-xs sm:text-sm tracking-[0.25em] uppercase mb-2 sm:mb-3">
            Applications
          </p>
          <h1 className="font-rajdhani text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800">
            Our Applications
          </h1>
          <p className="font-roboto text-slate-500 mt-3 sm:mt-4 text-sm sm:text-base max-w-xl mx-auto">
            Transforming architectural visions into glass reality across industries
          </p>
        </div>
      </section>

      {/* Applications List */}
      <section className="py-10 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 space-y-12 sm:space-y-20">
          {applications.map((app, index) => (
            <div
              key={app.id}
              data-testid={`application-${app.id}`}
              className="grid md:grid-cols-2 gap-6 sm:gap-12 items-center"
            >
              {/* Image */}
              <div className={`relative h-56 sm:h-[380px] overflow-hidden ${index % 2 === 1 ? 'md:order-2' : ''}`}>
                <img
                  src={app.image}
                  alt={app.name}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>

              {/* Content */}
              <div className={`space-y-4 sm:space-y-5 ${index % 2 === 1 ? 'md:order-1' : ''}`}>
                <p className="font-rajdhani text-brand font-semibold text-xs sm:text-sm tracking-[0.25em] uppercase">
                  Application #{String(app.id).padStart(2, '0')}
                </p>
                <h2 className="font-rajdhani text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800 leading-tight">
                  {app.name}
                </h2>
                <p className="font-roboto text-slate-600 text-sm sm:text-base leading-relaxed">
                  {app.description}
                </p>

                <div className="space-y-2 pt-1 sm:pt-2">
                  <h3 className="font-rajdhani text-base sm:text-lg font-semibold text-slate-800">Key Benefits</h3>
                  <ul className="space-y-2">
                    {app.benefits.map((benefit, i) => (
                      <li key={i} className="flex items-start gap-2 sm:gap-3">
                        <CheckCircle2 size={16} className="text-brand flex-shrink-0 mt-0.5" />
                        <span className="font-roboto text-slate-600 text-xs sm:text-sm">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-10 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="bg-brand p-8 sm:p-12 md:p-16 text-center">
            <h2 className="font-rajdhani text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-4">
              Don't See Your Application?
            </h2>
            <p className="font-roboto text-white/80 text-sm sm:text-base max-w-xl mx-auto mb-6 sm:mb-8">
              We specialize in custom glass solutions for unique projects.
              Let's discuss how we can bring your vision to life.
            </p>
            <Link
              to="/contact"
              data-testid="applications-contact-cta"
              className="inline-flex items-center gap-2 bg-white text-brand hover:bg-slate-100 font-rajdhani font-semibold px-6 sm:px-8 py-3 sm:py-3.5 text-sm sm:text-base transition-colors"
            >
              REQUEST CUSTOM SOLUTION
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ApplicationsPage;
